module.exports = __webpack_public_path__ + "static/media/bgi_privacy_keeping@2x.d6adf618.png";